/* eslint-disable no-shadow */
import React from 'react';
import { connect } from 'react-redux';
import MicSelectorContainer from '../../modules/scribe/MicSelectorContainer';
function CaptionsSettings({ currentPlatform, displayable, inTwilioCalls, isInConversation, muted, scribe, }) {
    const showComponent = currentPlatform === 'web' && !muted && !scribe && isInConversation && !inTwilioCalls && displayable.audio;
    return (React.createElement("div", { style: { display: showComponent ? 'inherit' : 'none' } },
        React.createElement(MicSelectorContainer, null)));
}
const mapStateToProps = ({ scribeConversation: { inTwilioCalls, isInConversation, muted, scribe }, scribeSession: { currentPlatform, displayable }, }) => ({
    currentPlatform,
    displayable,
    inTwilioCalls,
    isInConversation,
    muted,
    scribe,
});
export default connect(mapStateToProps, {})(CaptionsSettings);
